import { ref } from 'vue'
import axios from 'axios'
import { log } from "@/composables/useLog"
import { BASE_URL } from "@/composables/url_config"

const error = ref(null)

export const getMsisdnPricesList = async (token) => {
  log("welcome in getMsisdnPricesList")
  const API_URL = `${BASE_URL}/home/get_msisdn_prices_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.get(API_URL, { headers })
    log("result.data from getMsisdnPricesList:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in getMsisdnPricesList:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

export const addMsisdnPrice = async (token, data) => {
  log("welcome in addMsisdnPrice")
  const API_URL = `${BASE_URL}/home/add_msisdn_price_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.post(API_URL, data, { headers })
    log("result.data from addMsisdnPrice:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in addMsisdnPrice:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

export const updateMsisdnPrice = async (token, data) => {
  log("welcome in updateMsisdnPrice")
  const API_URL = `${BASE_URL}/home/update_msisdn_price_api`
  error.value = null
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
    const result = await axios.put(API_URL, data, { headers })
    log("result.data from updateMsisdnPrice:")
    log(result.data)
    return result.data
  } catch (err) {
    log("Error in updateMsisdnPrice:")
    log(err)
    error.value = err
    return { error: true, message: "Network error" }
  }
}

const useGetMsisdnPricesAPI = () => {
  return { getMsisdnPricesList, addMsisdnPrice, updateMsisdnPrice }
}

export default useGetMsisdnPricesAPI
